// Live vs Saved-for-later distinction for campaigns. A campaign is "saved" (a
// work-in-progress draft) until it is launched, at which point it becomes
// "live". Launched campaigns are preview-only; saved campaigns are editable.
// Derived purely from `status` — no schema change.

export const LAUNCHED_STATUSES = ['live', 'running', 'paused', 'ended', 'completed'];

export function isLaunched(status?: string): boolean {
  return !!status && LAUNCHED_STATUSES.includes(status);
}

export type CampaignFlag = 'live' | 'saved';

export function campaignFlag(status?: string): CampaignFlag {
  return isLaunched(status) ? 'live' : 'saved';
}
